import anniversaires from "../assets/HomePage/anniversaires.jpg";
import mariages from "../assets/HomePage/mariages.jpg";
import famille from "../assets/HomePage/famille.jpg";
import studio from "../assets/HomePage/studio.jpg";
import grossesseNaissance from "../assets/HomePage/grossesse-naissance.jpg";
import photobooth from "../assets/HomePage/photobooth.jpg";

// Catégories du portfolio.
// - slug : utilisé dans l'URL /portfolio/:slug (ne pas changer les anciens, ils sont indexés par Google)
// - folders : dossiers Cloudinary (clés de images.json) dont les photos sont affichées
// - subFolders : onglets, chacun lié au dossier Cloudinary "<slug>/<key>"
// - cover : photo de la tuile en page d'accueil (null = pas affichée sur l'accueil)
export const categories = [
  {
    slug: "Anniversaires",
    label: "Anniversaires",
    cover: anniversaires,
    folders: ["Anniversaires"],
    intro:
      "Anniversaires, EVJF, fêtes entre amis : des souvenirs pleins de rires et de spontanéité.",
  },
  {
    slug: "Mariages",
    label: "Mariages",
    cover: mariages,
    subFolders: [
      { key: "prep_mairie", label: "Préparatifs" },
      { key: "mairie", label: "Mairie" },
      { key: "eglise", label: "Église" },
      { key: "ceremonie_laique", label: "Cérémonie laïque" },
      { key: "shooting_couple", label: "Couple" },
      { key: "vin_honneur", label: "Vin d'honneur" },
      { key: "ouverture_bal", label: "Ouverture de bal" },
      { key: "soiree", label: "Soirée" },
      { key: "evjf", label: "EVJF" },
    ],
    intro:
      "Les préparatifs, les regards, les éclats de rire, les larmes… je raconte votre journée à travers des images naturelles et pleines d'émotions.",
  },
  {
    slug: "Famille",
    label: "Famille & Baptêmes",
    cover: famille,
    folders: ["Famille", "Baptemes"],
    intro:
      "Séances en famille et baptêmes : des moments de complicité à garder pour toujours.",
  },
  {
    slug: "Studio",
    label: "Studio",
    cover: studio,
    subFolders: [
      { key: "enfants", label: "Enfants" },
      { key: "mode", label: "Mode" },
      { key: "grossesse", label: "Grossesse" },
      { key: "couple", label: "Couple" },
    ],
    intro:
      "Portraits, couples, amis : une séance en home studio à Millam, dans une ambiance détendue.",
  },
  {
    slug: "Grossesse-Naissance",
    label: "Grossesse & Naissance",
    cover: grossesseNaissance,
    subFolders: [
      { key: "grossesse", label: "Grossesse" },
      { key: "naissance", label: "Naissance" },
    ],
    intro:
      "L'attente, puis l'arrivée de bébé : des séances douces, en studio ou à domicile.",
  },
  {
    slug: "Photobooth",
    label: "Photobooth",
    cover: photobooth,
    folders: ["Photobooth"],
    intro:
      "Mon photobooth est disponible à la location pour vos mariages, anniversaires et événements : vos invités repartent avec leurs tirages imprimés sur place.",
  },
  {
    slug: "Animaux",
    label: "Animaux",
    cover: null,
    folders: ["Animaux"],
    intro: "Vos compagnons à quatre pattes méritent aussi leur séance photo.",
  },
];

// Anciennes URLs (déjà indexées) redirigées vers la nouvelle catégorie
export const legacySlugs = { Baptemes: "Famille" };

export const findCategory = (slug) => {
  const target = legacySlugs[slug] || slug;
  return categories.find(
    (category) => category.slug.toLowerCase() === target?.toLowerCase()
  );
};
